import { assign } from 'lodash-es';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actionCreators from '../actionCreators';
import LeaveComment from '../components/LeaveComment';
import popover from '../hocs/popover';
function mapStateToProps(state) {
    return {
        isVisible: state.comment.leaveCommentPopoverVisible,
    };
}
function mergeProps(stateProps, _a, ownProps) {
    var dispatch = _a.dispatch;
    var newProps = {
        isPopoverOpen: stateProps.isVisible && ownProps.isPopoverOpen,
        togglePopover: function () {
            ownProps.togglePopover();
            dispatch(actionCreators.setLeaveCommentPopoverCookie());
        },
        onComponentDidMount: function () {
            dispatch(actionCreators.getLeaveCommentPopoverCookie());
        },
        onLeaveCommentClick: function () {
            dispatch(actionCreators.showComments());
            dispatch(actionCreators.setLeaveCommentPopoverCookie());
        },
    };
    return assign({}, ownProps, stateProps, newProps);
}
export default compose(popover(true), connect(mapStateToProps, null, mergeProps))(LeaveComment);
